import { render, staticRenderFns } from "./errorEmail.vue?vue&type=template&id=45398179&scoped=true&"
import script from "./errorEmail.vue?vue&type=script&lang=js&"
export * from "./errorEmail.vue?vue&type=script&lang=js&"
import style0 from "./errorEmail.vue?vue&type=style&index=0&id=45398179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45398179",
  null
  
)

export default component.exports